import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";
import { useThemeSettings } from "@internal/plugin-utilities";
import { radiatorDarkTheme, radiatorLightTheme } from "@internal/plugin-theme";

export interface Props {
  title: NonNullable<React.ReactNode>;
  [x: string]: any;
}

export const InformationTooltip: React.FC<Props> = (props) => {
  const themeSettings = useThemeSettings();
  const theme =
    themeSettings === "dark" ? radiatorDarkTheme : radiatorLightTheme;

  const styles = {
    arrow: {
      "&:before": {
        border: `1px solid ${theme.palette.background.default}`,
      },
      color: theme.palette.background.paper,
    },
    tooltip: {
      minWidth: "400px",
      padding: "10px 20px",
      color: themeSettings === "dark" ? "white" : "black",
      fontSize: "1.25em",
      borderRadius: "5px",
      border: `1px solid ${theme.palette.background.default}`,
      backgroundColor: theme.palette.background.paper,
    },
  };

  const CustomTooltip = withStyles(styles)(Tooltip);

  return (
    <CustomTooltip
      title={props.title}
      style={props.style || {}}
      className={props.className || ""}
      arrow
    >
      <InfoIcon />
    </CustomTooltip>
  );
};
